import React, { Component } from 'react'

class AZ extends Component {
  render() {
    return (
      <symbol id="statesvg-AZ" width="100" height="100" viewBox="0 0 100 100">
        <path d="M84.89,22.11l.78,69.55-25.2-.11L14.33,73.41l1.45-3.25H18l1-1.9L18.7,66l-2.24-1,.11-1.68-.45-1.91V60.3l1.12-.56,1.46-1.56.67-2.36L19,52.24,20.71,50l3.36-2.24-3-2.69L20.6,42.5l-2.13-3.59-.33-3.69L19,34.1l-1-4.48.45-5.27-.89-2.13L18,20.88l1.91-.56,2.24.56,1.45,1.57L25,22.22l.89-2.35.68-11.53,58.35.78Z" />
      </symbol>
    )
  }
}

export default AZ
